import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentIcon from "@material-ui/icons/Assignment";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SettingsIcon from "@material-ui/icons/Settings";
import TimelineIcon from "@material-ui/icons/Timeline";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../redux/actions/sidebarActions";
import { removeUserSession } from "../Utils/Common";
import { useStyles } from "../Utils/Styles";

export default function MainSidebarList() {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <div>
      <ListItem
        button
        onClick={() => {
          history.push("/dashboard");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.dashboard")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/devices");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <DevicesOtherIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.devices")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/monitoring");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <TimelineIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.monitoring")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/transports");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.transports")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/alerts");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.alerts")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/settings");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.settings")} />
      </ListItem>
      <ListItem button className={classes.sideBarButton}>
        <ListItemText
          primary={t("topbar.logout")}
          onClick={() => {
            removeUserSession();
            history.push("/login");
            dispatch(showSidebar(false));
          }}
        />
      </ListItem>
    </div>
  );
}
